export default __webpack_public_path__ + "static/media/bw-planning-tutorial-pop-up-step-2.0f030b0c.svg";